import React, { useContext, useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";
import ScheduleTimelineView from "./timeline-view";
import { CompanyContext } from "../../../../contexts/company-context";
import { BranchOperation } from "../../../../serviceoperation/BranchOperation";
import { LocationType } from "../../modal/location-types";

const ScheduleTimelineWrapper: React.FC = () => {
  const { selectedCompany } = useContext(CompanyContext);
  const branchOps = useMemo(() => new BranchOperation(), []);

  const [currentWeek, setCurrentWeek] = useState(() =>
    dayjs().startOf("week").toDate(),
  );
  const [selectedLocation, setSelectedLocation] = useState<string>("all");
  const [locations, setLocations] = useState<LocationType[]>([]);

  // Fetch locations/branches
  useEffect(() => {
    const fetchLocations = async () => {
      if (!selectedCompany?.corporationId) return;

      try {
        const response = await branchOps.getBranchAsync(
          selectedCompany.corporationId,
        );
        if (response.data) {
          setLocations(
            response.data.map((s) => ({
              key: s.branchID,
              name: s.name,
              color: s.color,
            })),
          );
          // Set first location as default
          if (response.data.length > 0) {
            setSelectedLocation(response.data[0].branchID.toString());
          }
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchLocations();
  }, [selectedCompany, branchOps]);

  const handleWeekChange = (direction: "prev" | "next" | "current") => {
    setCurrentWeek((current) => {
      if (direction === "current") {
        return dayjs().startOf("week").toDate();
      }
      const change = direction === "prev" ? -1 : 1;
      return dayjs(current).add(change, "week").toDate();
    });
  };

  return (
    <div style={{ padding: "16px 0" }}>
      {/* Timeline View */}
      <ScheduleTimelineView
        selectedLocation={selectedLocation}
        onLocationChange={setSelectedLocation}
        availableLocations={locations}
        currentWeek={currentWeek}
        onWeekChange={handleWeekChange}
      />
    </div>
  );
};

export default ScheduleTimelineWrapper;
